import React from "react";

export default (props, width=window.innerWidth-400, height=window.innerHeight-200, left=window.screenLeft+200, top=window.screenTop+200) => {
  const sizeAndPositions = `width=${width},height=${height},left=${left},top=${top}`;
  return <a onClick={() => {
    window.open(props.href,'popup',sizeAndPositions);
  }}>
    {props.children}
  </a>
}